import { Directive, ElementRef, Output, EventEmitter, OnInit, OnDestroy, NgZone } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';

@Directive({
  selector: '[currClickOutsideTags]'
})
export class ClickOutsideTagsDirective implements OnInit, OnDestroy {
  // TODO: check if output is correct here
  // tslint:disable-next-line:no-output-rename
  @Output('clickOutside') clickOutside: EventEmitter<any> = new EventEmitter();

  private onCapture = (event: Event) => {
    const targetElement = event.target as HTMLElement;
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside && targetElement && targetElement.nodeName !== 'svg' && targetElement.nodeName !== 'path' && targetElement.localName !== 'img') {
      this.zone.run(() => this.clickOutside.emit(null));
    }
  };

  constructor(
    private _elementRef: ElementRef,
    private zone: NgZone,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      this.document.addEventListener('click', this.onCapture, true);
    });
  }

  ngOnDestroy(): void {
    this.document.removeEventListener('click', this.onCapture, true);
  }
}
